module.exports = __webpack_public_path__ + "media/images/landing/USA-matrimony-banner3-08c7a269cabc3be44679a3cb5ba1a1f7.webp";